<template>
  <div class="wrapper font-en">
    <side-bar title="MY MUIC" backgroundColor="purple" activeColor="warning">
      <!-- MENU ZONE -->
      <template slot="links">
        <!-- <span class="ml-2">For User</span> -->
        <sidebar-link
          class="zoom-list"
          v-if="checkMsgWhoAmi(['faculty', 'staff', 'student'])"
          to="/portal"
          name="Portal"
          icon="fa fa-desktop"
        />
        <!-- <sidebar-link
          class="zoom-list"
          v-if="checkMsgWhoAmi(['faculty', 'staff', 'student'])"
          to="/atk"
        >
          <span style="font-size: 18px"
            ><i class="fa fa-heartbeat mr-3" aria-hidden="true" />MUIC Pass</span
          >
        </sidebar-link> -->
        <sidebar-link
          class="zoom-list"
          v-if="checkMsgWhoAmi(['faculty', 'staff', 'pc_lecturers'])"
          to="/calendar"
          name="Calendar"
          icon="fa fa-calendar"
        />
        <sidebar-link
          class="zoom-list"
          v-if="checkMsgWhoAmi(['faculty', 'staff', 'student'])"
          to="/icservice"
          name="Service"
          icon="fa fa-ticket"
        />
        <sidebar-link
          class="zoom-list"
          v-if="checkMsgWhoAmi(['faculty']) || checkMsgDev('TeamDev:admin')"
          to="/teaching"
          name="Teaching record"
          icon="fa fa-list"
        />
        <sidebar-link
          class="zoom-list"
          v-if="checkMsgWhoAmi(['faculty', 'staff', 'student'])"
          to="/icbooking"
          name="Booking"
          icon="fa fa-pencil-square-o"
        />
        <sidebar-link
          class="zoom-list"
          v-if="checkMsgWhoAmi(['faculty', 'staff'])"
          to="/icvehicle"
          name="IC Vehicle "
          icon="fa fa-car"
        />
        <sidebar-link
          class="zoom-list"
          v-if="checkMsgWhoAmi(['faculty', 'staff', 'student'])"
          to="/directory"
          name="Directory"
          icon="fa fa-search"
        />
        <sidebar-link
          class="zoom-list"
          v-if="checkMsgWhoAmi(['faculty', 'staff'])"
          to="/leaveofabsent"
          name="Leave of Absence"
          icon="fa fa-calendar"
        />
        <sidebar-link
          class="zoom-list"
          v-if="checkMsgWhoAmi(['faculty', 'staff', 'student'])"
          to="/checkinhistory"
          name="Campus access log"
          icon="fa fa-list-alt"
        />
        <sidebar-link
          class="zoom-list"
          v-if="checkMsgWhoAmi(['student'])"
          to="/studentactivity"
          name="Student Activity"
          icon="fa fa-folder-open-o"
        />
        <sidebar-link
          class="zoom-list"
          v-if="checkMsgWhoAmi(['student'])"
          to="/jobfair"
          name="Job Application"
          icon="fa fa-suitcase"
        />
        <sidebar-link
          class="zoom-list"
          v-if="checkMsgWhoAmi(['student'])"
          to="/tuitionpayment"
          name="QR payment"
          icon="fa fa-dollar"
        />
        <!-- For Admin -->
        <span
          v-if="this.$store.state.permit.RulesUser.permissions.length > 0"
          class="ml-4 mt-3 zoom-list"
          style="font-size: 1.1rem"
        >
          <b-link
            class="font-en"
            style="color: #d0d0d0"
            target="_blank"
            href="https://my.muic.io/admin/#/mainadmincard"
          >
            <i class="fa fa-sitemap"></i>IC Manage
          </b-link>
        </span>
        <!-- <sidebar-link class="zoom-list" v-if="checkMsgWhoAmi(['faculty']) || checkMsgDev('TeamDev:admin')" to="/teachingwage" name="Teaching wage" icon="fa fa-calculator"/> -->
        <!-- For Admin -->
        <!-- <sidebar-link class="custom-font" v-if="checkMsgWhoAmi(['staff'])" to="/document"  name="Document" icon="fa fa-folder"/> -->
        <!-- user Lecture pages v-if="checkMsgWhoAmi('faculty') || checkMsgDev('TeamDev:admin')" -->
        <!-- <sidebar-link v-if="checkMsgWhoAmi(['faculty','staff','student'])" to="/class_schule" name="Class schedule" icon="fa fa-calendar"/> -->
        <!-- <sidebar-link v-if="newStdMenu && checkMsgWhoAmi('student')" to="/muaccount" name='MU Account' icon="fa fa-info"/>  -->
        <!-- <sidebar-link v-else-if="checkMsgWhoAmi('student')" to="/notpermit" name="MU Account" icon="fa fa-info"/> -->
        <!-- <sidebar-link to="/backoffice" name="Back Office" icon="fa fa-desktop"/> -->
      </template>
      <mobile-menu>
        <drop-down
          class="nav-item moblie-font"
          :title="$keycloak.fullName"
          title-classes="nav-link"
          icon="fa fa-user-circle-o"
        >
          <b-dropdown-item to="/profile">Profile</b-dropdown-item>
          <b-dropdown-item :href="$keycloak.createLogoutUrl()"
            >Log out</b-dropdown-item
          >
        </drop-down>
        <li class="divider"></li>
      </mobile-menu>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar"></dashboard-content>
      <content-footer></content-footer>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Nunito:wght@600&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Nunito:wght@600&display=swap");
.moblie-font {
  font-family: "Nunito", sans-serif;
  font-weight: 100;
  color: #fff;
}
.font-en {
  font-family: "Nunito", sans-serif;
}
.zoom-list {
  transition: transform 0.2s; /* Animation */
}
.zoom-list:hover {
  transform: scale(1.1);
}
</style>

<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
import { mapGetters, mapActions } from "vuex";
import store from "@/store/index";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
  },
  data() {
    return {
      newStdMenu: true,
    };
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    ...mapGetters({
      msg: "getRules",
    }),
  },
  mounted() {
    this.whoAmIcontent();
    // this.checkMsgWhoAmi()
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    async whoAmIcontent() {
      var count = 0;
      for (
        let index = 0;
        index < this.$store.state.permit.RulesUser.roles.length;
        index++
      ) {
        if (
          this.$route.meta.permitC.includes(
            this.$store.state.permit.RulesUser.roles[index]
          )
        ) {
          count++;
        }
        // console.log(this.$store.state.permit.RulesUser.roles[index])
        // console.log(this.$route.meta.permitC.includes(this.$store.state.permit.RulesUser.roles[index]))
      }
      // console.log(count)
      if (count == 0) {
        this.$router.push("/accountpermit").catch((err) => {});
      }
    },
    checkMsgWhoAmi(ValueChk) {
      var count = 0;
      for (let index = 0; index < ValueChk.length; index++) {
        if (
          this.$store.state.permit.RulesUser.roles.includes(ValueChk[index])
        ) {
          count++;
        }
      }
      return count > 0 ? true : false;
    },
    checkMsgDev(ValueChk) {
      return this.msg.permissions.includes(ValueChk);
    },
  },
};
</script>
